// extracted by mini-css-extract-plugin
module.exports = {"root":"State_root__k1ggO","svg":"State_svg__3s-7c"};